<template>
    <ul class="service-list list-horizontal">
        <li class="" v-for="service in services">
            <div :class="{active: isActiveService(service)}" @click="selectService(service)" class="service-list-item">
                <figure class="icon"><img :alt="$t('service.'+service.id)" :src="service.image"></figure>
                {{$t("service."+service.id)}}
            </div>
        </li>

    </ul>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "ServiceList",
        data: function () {
            return {}
        },
        computed: mapState({
            services: state => state.services
        }),
        methods: {
            selectService(service) {
                this.$store.commit('selectService', service.id);
                this.$router.push({name: service.id})
            },
            isActiveService(service) {
                return this.$store.getters.isActiveService(service.id);
            }
        },
        created() {

        }
    }
</script>

<style scoped>
    .service-list-item a:hover {
        text-decoration: none;
    }

    .service-list-item a {
        color: inherit;

    }
</style>
